const thirdStepData = {
    photoAadhar: null,
    photoAadharFileName: '',
    photoAadharImagePreviewUrl: '',
    photoBirth: null,
    photoBirthFileName: '',
    photoBirthImagePreviewUrl: '',
    photoFatherAadhar: null,
    photoFatherAadharFileName: '',
    photoFatherAadharImagePreviewUrl: '',
    photoMotherAadhar: null,
    photoMotherAadharFileName: '',
    photoMotherAadharImagePreviewUrl: '',
    };
  
  
    export default thirdStepData;
    